/**
 * Product front door — which Waypoint product a brand-new signup is for.
 *
 * Sales, Clients and SOW Desk are standalone products: someone who arrives
 * through /sales/start, /clients/start or /sow/start must land in a workspace
 * for that product, never the owner dashboard. The flag is set by the product's
 * /start route (routes/public/ProductStart.tsx), rides along as
 * X-Waypoint-Product on the first authenticated API call (the one that
 * provisions the workspace — see apps/api infra/auth.ts ensureAccount +
 * domain/products.ts), and is cleared once a call succeeds.
 *
 * Mirrors lib/attribution.ts. Wrapped in try/catch: storage can be blocked.
 */

const KEY = 'waypoint.product';
export const PRODUCT_KEYS = ['sales', 'clients', 'sow'] as const;
export type ProductKey = (typeof PRODUCT_KEYS)[number];

export function isProductKey(v: unknown): v is ProductKey {
  return (PRODUCT_KEYS as readonly string[]).includes(v as string);
}

export function setProduct(p: ProductKey): void {
  try { localStorage.setItem(KEY, p); } catch { /* storage blocked */ }
}

export function readProductHeader(): ProductKey | null {
  try {
    const v = localStorage.getItem(KEY);
    return isProductKey(v) ? v : null;
  } catch { return null; }
}

export function clearProduct(): void {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
